<template>
  <rid-field
    :label="patent.protection.kind"
    :value="patent.protection.number + ' от ' + formatDate(patent.protection.priorityDate)"
    icon="mdi-file-certificate-outline"
  />
  <rid-field
    v-if="!compact"
    :label="application.kind"
    icon="mdi-text-box-check-outline"
    :value="
      (application.number ?? '&mdash;') +
      ' от ' +
      (application.date ? formatDate(application.date) : '&mdash;')
    "
  />
  <rid-field
    v-if="(application.pctNumber || application.pctDate) && !compact"
    label="Заявка PCT"
    icon="mdi-web"
    :value="
      (application.pctNumber ?? '&mdash;') +
      ' от ' +
      (application.pctDate ? formatDate(application.pctDate) : '&mdash;')
    "
  />
  <rid-field
    v-if="patent.scope && !compact"
    label="Сфера применения"
    :value="patent.scope"
    icon="mdi-factory"
  />
  <rid-field
    v-if="hasItems(patent.objects) && !compact"
    label="Объекты техники"
    :value="patent.objects.join(', ')"
    icon="mdi-subway-variant"
  />
</template>

<script setup>
import moment from 'moment'
import RidField from '@/components/Rid/RidField.vue'

defineProps({
  patent: {
    type: Object,
    required: true,
  },
  application: {
    type: Object,
    required: true,
  },
  compact: {
    type: Boolean,
    required: true,
  },
})

const hasItems = (arr) => Array.isArray(arr) && arr.length > 0

const formatDate = (unixtime) => moment.unix(unixtime).format('YYYY-MM-DD')
</script>

<style scoped lang="scss">

</style>
